import React, { useState, useMemo } from "react";
import { Row, Col, Typography, Card, Checkbox } from "antd";

import ImageBox from "components/ImageBox";
import { gaEvent } from "analytics/analytics";
import * as GA from "constants/analytics";
import { ProductDetailsCreateModal } from "components/ProductDetailsModal";

const { Title, Text } = Typography;

function ProductCard({ item, index, handleProductSelection, isChecked }) {
  const [modalData, setModalData] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const handleModal = (value) => {
    setShowModal(value);
  };
  const handleCardClick = (item) => {
    setModalData((state) => item);
    handleModal(true);
  };

  const comp = useMemo(() => {
    return (
      <Col key={item?.id} xs={24} sm={24} md={12} lg={8} xl={8}>
        <ProductDetailsCreateModal
          showModal={showModal}
          setShowModal={setShowModal}
          handleProductSelection={(e) => {
            handleProductSelection(e, modalData, !isChecked);
          }}
          isSelected={isChecked}
          id={modalData?.id}
        />
        <Card
          key={item?.secondary_category_id?.id}
          className="product-card"
          cover={
            <ImageBox
              imgUrl={
                item && item.product_images[0]
                  ? `${process.env.REACT_APP_CLOUDINARY}/c_lpad,h_214,q_100,w_283/${item?.product_images[0]?.directus_files_id}`
                  : "http://placehold.jp/24/0a8f8d/ffffff/283x214.png?text=Product Image"
              }
              fallbackUrl={
                item && item.product_images[0]
                  ? `${process.env.REACT_APP_DIRECTUS}assets/${item?.product_images[0]?.directus_files_id}?transforms=[["resize",{"width":283,"height":214,"fit":"contain","background":"white"}]]`
                  : "http://placehold.jp/24/0a8f8d/ffffff/283x214.png?text=Product Image"
              }
              alt={"product name"}
              onClick={() => handleCardClick(item)}
              shimmerStyles={{
                height: 222,
                borderTopLeftRadius: "0.5rem",
                borderTopRightRadius: "0.5rem",
              }}
              imgIndex={index}
            />
          }
        >
          {item?.is_exclusive_product ? (
            <span
              style={{
                background: "rgba(66, 135, 245)",

                top: 0,
                right: 0,
                margin: "1rem",
                position: "absolute",
                borderRadius: "2rem",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-around",
                alignItems: "center",
                width: "7rem",
                padding:"0.2em"
              }}
            >
              <Text
                style={{
                  fontWeight: "bold",
                  fontSize: "16px",
                  color: "white",
                  fontStyle: "normal",
                }}
              >
                Exclusive
              </Text>
            </span>
          ) : null}

          <Checkbox
            className="select-product"
            checked={isChecked}
            onChange={(e) => handleProductSelection(e, item, !isChecked)}
            style={{ top: 0, position: "absolute", marginTop: 12 }}
            onClick={() => {
              gaEvent(
                GA.EVENT.CLICK,
                GA.CATEGORY.CREATE_COLLECTION,
                GA.DESCRIPTION.CREATE_COLLECTION_SELECT_PRODUCT_CHECKED,
                item?.product_id
              );
            }}
          />

          <Row>
            <Title className="product-id" type="secondary" level={5}>
              ID : {item?.product_id ? item?.product_id : "No product id"}
            </Title>
          </Row>
        </Card>
      </Col>
    );
  }, [item, index, handleProductSelection, isChecked, showModal]);

  return comp;
}

export default ProductCard;
